import React from 'react';
import { Outlet } from 'react-router-dom';
import './Dashboard.css';
import TopBar from './TopBar';
import SideBar from './SideBar';

const Dashboard = () => {
  return (
    <div className="dashboard-container">
      <TopBar disableDashboardLink={false} />
      <div className="dashboard-body">
        <SideBar />
        <main className="dashboard-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
